/**
 * Local Storage Wishlist Engine (no external app dependency).
 * Storage access is guarded so private-mode / blocked-storage browsers never throw.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'uae_store_wishlist_items';

  window.WishlistEngine = {
    getItems() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        return [];
      }
    },

    saveItems(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      } catch (e) { /* storage unavailable */ }
      this.updateBadges();
    },

    toggle(productId, title, handle) {
      const items = this.getItems();
      const index = items.findIndex((item) => item.id === productId);

      if (index > -1) {
        items.splice(index, 1);
      } else {
        items.push({ id: productId, title, handle, addedAt: Date.now() });
      }

      this.saveItems(items);
      this.updateButtonStates();
      return index === -1; // true if added
    },

    isWishlisted(productId) {
      return this.getItems().some((item) => item.id === productId);
    },

    updateBadges() {
      const count = this.getItems().length;
      document.querySelectorAll('.wishlist-count-badge').forEach((badge) => {
        badge.textContent = count;
        badge.classList.toggle('hidden', count === 0);
      });
    },

    updateButtonStates() {
      const items = this.getItems();
      document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
        const active = items.some((item) => item.id === btn.dataset.productId);
        const icon = btn.querySelector('.wishlist-icon');
        btn.classList.toggle('text-rose-600', active);
        if (icon) icon.classList.toggle('fill-rose-600', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        const label = active ? btn.dataset.labelRemove : btn.dataset.labelAdd;
        if (label) btn.setAttribute('aria-label', label);
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.WishlistEngine.updateBadges();
    window.WishlistEngine.updateButtonStates();

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      window.WishlistEngine.toggle(btn.dataset.productId, btn.dataset.productTitle, btn.dataset.productHandle);
    });
  });
})();
